import { Component } from '@angular/core';

@Component({
  selector: 'app-about-tickets',
  templateUrl: './about-tickets.component.html',
  styleUrls: ['./about-tickets.component.less'],
})
export class AboutTicketsComponent {

}
